(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.formulari.controller:FormulariCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.formulari')
    .controller('EntitatsMainSubmainFormulariCtrl', EntitatsMainSubmainFormulariCtrl);

  function EntitatsMainSubmainFormulariCtrl(EntitatFactory, entitatData, $rootScope, $stateParams, $state, HelperFactory, Notification,$translate) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainSubmainFormulariCtrl';
    vm.isNew =angular.isUndefined(entitatData.data);

    vm.entitat = [];
    vm.maxlength = 100;

    if (angular.isUndefined(entitatData.data)){
      vm.entitat = {};
    }
    else {
      vm.entitat = entitatData.data;
    }

     vm.tipus_empresaList = [{id:'interno', name: $translate.instant('interno')},
                    {id:'externo', name: $translate.instant('externo')}]

     for (var i=0;i < vm.tipus_empresaList.length;i++){
      if (vm.entitat.tipus_client==vm.tipus_empresaList[i].id ) {
        vm.entitat.tipus_empresaObj=vm.tipus_empresaList[i];
        break;
      }
     }


    vm.formulari = {
        nom: 'formulari',
        func: func,
        camps: [
          {
            type: 'text',
            name: 'nom',
            label: 'DEFAULT_NOM',
            required: true,
            columns: 6,
            maxLength: 100
          },
          {
            type: 'text',
            name: 'nif',
            label: 'DEFAULT_NIF',
            required: true,
            columns: 6,
            maxLength: 20
          },
          {
            type: 'text',
            name: 'codi',
            label: 'DEFAULT_CODI',
            columns: 6,
            maxLength: vm.maxlength,
            disabled:true
          },
          {
            type: 'text',
            name: 'codiclient',
            label: 'DEFAULT_CODI_client',
            columns: 6,
            maxLength: 50,
            required: true
          },
          {
              type: 'select',
              name: 'tipus_empresaObj',
              propertyLabel: 'name',
              propertyId: 'id',
              label: 'DEFAULT_TIPUS',
              list: vm.tipus_empresaList ,
              columns: 6,
              required: true,
          },
          {
             type: 'checkbox',
             name: 'bloquejada',
             columns: 6,
             label: 'DEFAULT_BLOQUEJADA'
          }
        ]
      };

    vm.errors = [];
    vm.back = back;

    function func(){
      vm.entitat.tipus_client= vm.entitat.tipus_empresaObj.id;
      if (vm.isNew){
          EntitatFactory.add(vm.entitat).then(function (response){
            vm.entitat.id = response.data;
            $rootScope.$broadcast('entitats.main.llista.add', vm.entitat);
            HelperFactory.setParams($stateParams, {'idEntitat': response.data});
            $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
      }
      else {
          EntitatFactory.update($stateParams.idEntitat, vm.entitat).then(function (response){
            $rootScope.$broadcast('entitats.main.llista.update', vm.entitat);
            $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
      }
    }

    function back() {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      if (vm.isNew) {
        $state.go('entitats.main', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else {
        $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
    }

    if (vm.isNew) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }
  }
}());
